export const experimentsOnLoading = {};
export const releaseLock = (projectId) => {
    if (!projectId) {
        throw new Error('Missing projectId!');
    }
    experimentsOnLoading[projectId] = false;
};
export const setLock = (projectId) => {
    if (!projectId) {
        throw new Error('Missing projectId!');
    }
    experimentsOnLoading[projectId] = true;
};
export const isLocked = (projectId) => {
    if (!projectId) {
        throw new Error('Missing projectId!');
    }
    return !!experimentsOnLoading[projectId];
};
//# sourceMappingURL=lockExperiment.js.map